export enum TextboxValueChangeEvent {
    Change = 'change',
    KeyUp = 'keyup',
    ChangeAndKeyUp = 'keyup change'
}